export interface PlotStep {
  stage: string;
  title: string;
  content: string;
}

export const plotSteps: PlotStep[] = [
  {
    stage: '起',
    title: '暑假出走',
    content:
      '就读高中的富家女阿珍（Jane）本应听从父母安排，利用暑假前往英国进修英文。性格叛逆的她却把机票转赠给好友，自己悄悄前往男友 John 的住处，想给对方一个意外的惊喜，共度二人世界。',
  },
  {
    stage: '承',
    title: '撞见背叛',
    content:
      '满心期待的阿珍却发现 John 背着她另结新欢，感情上的不忠让她从惊喜跌入失望。一气之下，她收拾行李离家出走，独自踏上没有目的地的旅途。',
  },
  {
    stage: '转',
    title: '旅途险境',
    content:
      '在野外游历时，阿珍险遭歹徒侵犯，所幸侥幸逃脱。这段惊险经历让她更加警觉，也第一次直面独自远行的代价与其中的成长。',
  },
  {
    stage: '合',
    title: '邂逅作家',
    content:
      '旅途中，阿珍邂逅了年轻的作家 David，两人一见钟情，擦出爱火。漂泊的旅程因为这段相遇有了新的方向。',
  },
  {
    stage: '结',
    title: '成长与重逢',
    content:
      '经历过一系列波折与短暂的分离后，阿珍对自由与爱情有了更成熟的感悟，最终与 David 重修旧好，坦然面对自己的心灵成长。',
  },
];